import styled from 'styled-components';
import { flex } from '@/styles/minix';

export const PAvatarNameWrap = styled.div`
	${flex('row', 'flex-start', 'center')};

	> .major-name {
		margin-left: 10px;
	}
	> .infior-name {
		margin-left: 10px;
		font-size: 12px;
		color: #a9adba;
		padding-top: 2px;
	}
`;
